export class AppSettings {
    public static API_ENDPOINT='http://150.129.116.146:8081/api/';
 } 


// WEBPACK FOOTER //
// ./src/app/app.settings.ts